//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "my-integral",
    data() {
        return {
            pointCatgs: [
                {
                    img: require('@/assets/img/points1.png'),
                    name: '积分明细',
                    entryType: -1
                },
                {
                    img: require('@/assets/img/points2.png'),
                    name: '积分收入',
                    entryType: 0
                },
                {
                    img: require('@/assets/img/points3.png'),
                    name: '积分支出',
                    entryType: 1
                },
            ],
            point: 0,
            currrentMemberPoint: 0,
            entryType: -1,
            pageIndex: 1,
            pageSize: 10,
            refreshing: false,
            loading: false,
            finished: false,
            list: [],
            totalPoint: 0,
            memberInfo: {}
        }
    },
    methods: {
        getCurrentPoint() {
            // 当前可用积分
            abp.ajax.get('/api/services/app/PointAccount/GetCurrentPoint').then(res => {
                this.currrentMemberPoint = res.data.result;
            });
        },
        getPoint(id) {
            // 总积分
            abp.ajax.get('/api/services/app/PointAccount/GetPointAccount?correlationId=' + this.memberInfo.id + '&accountType=0').then(res => {
                this.totalPoint = res.data.result.balance;
            });
        },
        onRefresh(t) {
            this.entryType = t;
            this.pageIndex = 1;
            this.getList();
        },
        onLoad() {
            this.pageIndex++;
            this.getList();
        },
        getList() {
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            var params = {
                accountCorrelationId: localStorage.getItem('MemberId'),
                accountType: 0,
                entryType: this.entryType < 0 ? '' : this.entryType,
                filter: '',
                sorting: '',
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize
            };
            abp.ajax.post('/api/services/app/PointAccount/SearchPointAccountDetails', params).then(res => {
                // console.log('items：%@', res.data.result.items);
                if (this.pageIndex === 1) {
                    this.list = [];
                }
                this.list.push(...res.data.result.items);
                if (res.data.result.items.length < this.pageSize) {
                    this.finished = true;
                }
            }, error => {
                // console.log(error);
                this.refreshing = false;
                this.loading = false;
            }).catch(() => {
            }).then(() => {
                this.refreshing = false;
                this.loading = false;
            });
        },
        async getMyMember() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                this.memberInfo = this.$store.state.member.memberInfo;
                localStorage.setItem('MemberId', this.memberInfo.id);

                this.getCurrentPoint();
                this.getPoint();

                this.onRefresh();

            }).finally(() => {
                this.$toast.clear();
            });
        },
    },
    created() {
        this.getMyMember();
    }
}
